import { CubeTimeDimensionGranularity } from '../../../common/enum/cube-time-dimension-granularity.enum';
import { CubeRequestConfig } from '../../../common/interface/cube-request-config.interface';

export interface GetSelfAllScoresRequestDto {
  params: {
    startDate: string;
    endDate: string;
    timezone?: string;
    granularity: CubeTimeDimensionGranularity;
  };
  config: CubeRequestConfig;
}
